import Vue from 'vue';
import VueRouter from 'vue-router';
import VueMeta from 'vue-meta';

Vue.use(VueRouter);
Vue.use(VueMeta);

const routes = [
  {
    path: '/',
    name: 'Home',
    beforeEnter() {
      window.location = 'https://www.viabus.co';
    },
  },
  {
    path: '/user/sndchgpwd',
    name: 'SendChangePasswordEmail',
    component: () =>
      import(
        /* webpackChunkName: "SendChangePasswordEmail" */ '../views/change-password-email.vue'
      ),
  },
  {
    path: '/user/chgpwd',
    name: 'ChangePassword',
    component: () =>
      import(/* webpackChunkName: "ChangePassword" */ '../views/change-password.vue'),
  },
  {
    path: '/m/*',
    name: 'DynamicLink',
    component: () => import(/* webpackChunkName: "DynamicLink" */ '../views/download.vue'),
  },
  {
    path: '/user/verify',
    name: 'VerifyEmail',
    component: () => import(/* webpackChunkName: "VerifyEmail" */ '../views/verify-email.vue'),
  },
  {
    path: '/link/expired',
    name: 'LinkExpired',
    component: () => import(/* webpackChunkName: "LinkExpired" */ '../views/link-expired.vue'),
  },
  {
    path: '/link/invalid',
    name: 'LinkInvalid',
    component: () => import(/* webpackChunkName: "LinkInvalid" */ '../views/link-invalid.vue'),
  },
  {
    path: '*',
    redirect: { name: 'Home' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
